import { i18nNsFactory } from '@atlas-frontend/i18n';
import { useMemo } from 'react';
import translations from '../translations/useKeyOptions.translations.json';
import { useKeyClassifiers } from './useKeyClassifiers';

const { addTranslations, useTranslation } = i18nNsFactory('keys-form-table');
addTranslations(translations);

export function useKeyOptions(indicatorStatus?: boolean) {
  const { t } = useTranslation();
  const {
    statusClassifiers,
    recipientClassifiers,
    ruleClassifiers,
    ruleValueClassifiers,
  } = useKeyClassifiers();

  const options = useMemo(
    () => ({
      voluntary: [
        { id: true, name: t('label.voluntary.yes') },
        { id: false, name: t('label.voluntary.no') },
      ],
      recipientIds: recipientClassifiers.map((option) => ({
        id: option.value,
        name: option.label,
      })),
      ruleTypeId: (indicatorStatus
        ? ruleClassifiers
        : ruleValueClassifiers
      ).map((option) => ({
        id: option.value,
        name: option.label,
      })),
      statusId: statusClassifiers.map((option) => ({
        id: option.value,
        name: option.label,
      })),
    }),
    [
      indicatorStatus,
      recipientClassifiers,
      ruleClassifiers,
      ruleValueClassifiers,
      statusClassifiers,
      t,
    ]
  );

  return {
    options,
    recipientClassifiers,
    ruleClassifiers: indicatorStatus ? ruleClassifiers : ruleValueClassifiers,
    statusClassifiers,
  };
}
